export enum NavigationRoute {
    Default = "/",
    Login = "/login",
    Dashboard = "/dashboard",
    ProjectDetails = "/project-details",
}
